interface DatadogConfig {
  DdrAppId: string;
  DdrClientToken: string;
  DdrSite: string;
  DdrService: string;
  DdrEnv: string;
  CurrentEnv: string;
}
const defaultDatadogConfig: DatadogConfig = {
  DdrAppId: "",
  DdrClientToken: "",
  DdrSite: "",
  DdrService: "",
  DdrEnv: "",
  CurrentEnv: ""
};
let isInitiated = false;
import { datadogRum } from "@datadog/browser-rum";

const initializeDatadogRum = (config: DatadogConfig = defaultDatadogConfig) => {
  if (config.CurrentEnv === "dev" || isInitiated) {
    return;
  }
  
  isInitiated = true;

  // Safe version handling
  const version = (process.env.BUILD_VERSION as any)?.commit || 'dev';
  
  return datadogRum.init({
    applicationId: config.DdrAppId,
    clientToken: config.DdrClientToken,
    site: config.DdrSite,
    service: config.DdrService,
    env: config.DdrEnv,
    sessionSampleRate: 50,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackingConsent: 'granted',
    defaultPrivacyLevel: "mask-user-input",
    version,
  });

};

export default initializeDatadogRum;
